// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resumeupload-container input {
  cursor: pointer;
}
.resumeupload-container .upload-box {
  border: 1px solid #dee4f0 !important;
}
.resumeupload-container .upload-box:hover {
  border: 1px solid #d1d6e1 !important;
}
.resumeupload-container .cv-upload-overlay {
  cursor: not-allowed;
  background-color: rgba(255, 255, 255, 0.5);
}
.resumeupload-container .cloud-img {
  border: 1px solid #dee4f0;
  border-radius: 0.5rem;
  margin: 1rem auto 0.5rem;
  padding: 0.4rem 0.5rem;
  height: 32px;
  width: fit-content;
}
.resumeupload-container .check-icon {
  background-color: #0A56AE;
  border-radius: 50%;
  color: #FFF;
  font-size: 10px;
  height: 15px;
  width: 15px;
  text-align: center;
}
.resumeupload-container .clear-btn {
  background-color: #FFF;
  border: 1px solid #c5d2c8;
  border-radius: 0.5rem;
  color: #000;
}
.resumeupload-container .parse-btn {
  background-color: #FFF;
  border: 1px solid #0A4FAE;
  border-radius: 0.5rem;
  box-shadow: 0 0 0 0.25px #0A4FAE;
  color: #0A4FAE;
}
.resumeupload-container .parse-btn:disabled {
  color: #767F8C;
  border: 1px solid #767F8C;
  box-shadow: 0 0 0 0.25px #767F8C;
}`, "",{"version":3,"sources":["webpack://./../jobportal/src/components/PortalApplicationContent/ResumeUpload/ResumeUpload.scss"],"names":[],"mappings":"AACE;EACE,eAAA;AAAJ;AAGE;EACE,oCAAA;AADJ;AAIE;EACE,oCAAA;AAFJ;AAKE;EACE,mBAAA;EACA,0CAAA;AAHJ;AAME;EACE,yBAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAJJ;AAOE;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AALJ;AAQE;EACE,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;AANJ;AASE;EACE,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gCAAA;EACA,cAAA;AAPJ;AAUE;EACE,cAAA;EACA,yBAAA;EACA,gCAAA;AARJ","sourcesContent":[".resumeupload-container {\n  input {\n    cursor: pointer;\n  }\n\n  .upload-box {\n    border: 1px solid #dee4f0 !important;\n  }\n\n  .upload-box:hover {\n    border: 1px solid #d1d6e1 !important;\n  }\n\n  .cv-upload-overlay {\n    cursor: not-allowed;\n    background-color: rgba(255, 255, 255, 0.5);\n  }\n\n  .cloud-img {\n    border: 1px solid #dee4f0;\n    border-radius: 0.5rem;\n    margin: 1rem auto 0.5rem;\n    padding: 0.4rem 0.5rem;\n    height: 32px;\n    width: fit-content;\n  }\n\n  .check-icon {\n    background-color: #0A56AE;\n    border-radius: 50%;\n    color: #FFF;\n    font-size: 10px;\n    height: 15px;\n    width: 15px;\n    text-align: center;\n  }\n\n  .clear-btn {\n    background-color: #FFF;\n    border: 1px solid #c5d2c8;\n    border-radius: 0.5rem;\n    color: #000;\n  }\n\n  .parse-btn {\n    background-color: #FFF;\n    border: 1px solid #0A4FAE;\n    border-radius: 0.5rem;\n    box-shadow: 0 0 0 0.25px #0A4FAE;\n    color: #0A4FAE;\n  }\n\n  .parse-btn:disabled {\n    color: #767F8C;\n    border: 1px solid #767F8C;\n    box-shadow: 0 0 0 0.25px #767F8C;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
